function render(h, { definition, remark }) {
  return (
    <el-popover
     placement="top-start"
     width="200"
     trigger="hover">
      <div class="data-analysis-meta-info">
       <p><span>定义:</span> { definition }</p>
       <p><span>备注</span> { remark }</p>
      </div>
      <i slot="reference" class="el-icon-info data-analysis-meta-info-icon"></i>
    </el-popover>
  )
}

export default [
  {
    prop: 'amount_with_refund',
    label: '销售总额',
    form: {
      component: 'switch'
    }
  },
  {
    prop: 'amount',
    label: '支付总额',
    form: {
      component: 'switch'
    },
    metaRender(h) {
      return render(h, {
        definition: '销售总额 - 退货总额',
        remark: '选中某个想计算的时间范围后，退货总额指该范围内支付的订单退货成功的退款总额（退款动作不局限于该时间范围内）。',
      })
    }
  },
  {
    prop: 'refund_amount',
    label: '退款总额',
    form: {
      component: 'switch'
    }
  },
  {
    prop: 'order_count',
    label: '订单数',
    form: {
      component: 'switch'
    }
  },
  {
    prop: 'paid_order_count',
    label: '支付订单数',
    metaRender(h) {
      return render(h, {
        definition: '未退货的支付订单数',
        remark: '订单中的商品没有全部退掉也算为未退货'
      })
    },
    form: {
      component: 'switch'
    }
  },
  {
    prop: 'item_count',
    label: '成交件数',
    form: {
      component: 'switch'
    },
    metaRender(h) {
      return render(h, {
        definition: '支付订单成交件数',
        remark: '包含退款的',
      })
    }
  },
  {
    prop: 'refund_count',
    label: '退款单数',
    form: {
      component: 'switch'
    }
  },
  {
    prop: 'refund_item_count',
    label: '退款件数',
    form: {
      component: 'switch'
    }
  },
  {
    prop: 'user_count',
    label: '买家数',
    form: {
      component: 'switch'
    }
  },
  {
    prop: 'paid_user_count',
    label: '支付买家数',
    form: {
      component: 'switch'
    },
    meta: {
      definition: '未退货的支付买家数',
    remark: '未退货定义同上'
    }
  },
  {
    prop: 'per_customer_price_with_refund',
    label: '客单价(含退货)',
    form: {
      component: 'switch'
    },
    metaRender(h) {
      return render(h, {
        definition: '支付总额 / 支付订单数',
        remark: '另一个指标“客单价(含退货)”定义为：销售总额 / 支付订单数(含退货)'
      })
    }
  },
  {
    prop: 'per_customer_item_with_refund',
    label: '客单件(含退货)',
    form: {
      component: 'switch'
    },
    metaRender(h) {
      return render(h, {
        definition: '销售总件数(不含退货) / 支付订单数',
        remark: '另一个指标 客单件(含退货) 定义为：销售总件数 / 支付订单数(含退货)'
      })
    }
  },
  {
    prop: 'per_customer_price',
    label: '客单价(支付总额 / 支付订单数)',
    form: {
      component: 'switch'
    }
  },
  {
    prop: 'per_customer_item',
    label: '客单件(销售总件数(不含退货) / 支付订单数)',
    form: {
      component: 'switch'
    }
  },
  {
    prop: 'page_view',
    label: '店铺页面浏览量(PV)',
    form: {
      component: 'switch'
    }
  },
  {
    prop: 'user_view',
    label: '店铺访客数(UV)',
    form: {
      component: 'switch'
    },
    metaRender(h) {
      return render(h, {
        definition: '从微信小程序获取到的访客数',
        remark: '因为微信数据只能一天一天地获取，不能获取一段时间内的，所以计算出来的总量会有偏差（偏大）。另外，店铺访客数和店铺浏览量只能获取到昨天的数据，今天的数据获取不到。'
      })
    }
  },
  {
    prop: 'shop_bag_item_count',
    label: '加入购物车次数',
    form: {
      component: 'switch'
    }
  },
  {
    prop: 'order_rate',
    label: '浏览-下单转化率(下单买家数 / 店铺访客数)',
    form: {
      component: 'switch'
    },
    metaRender(h) {
      return render(h, {
        definition: '下单买家数 / 店铺访客数',
        remark: '受到店铺访客数的影响，一段时间内计算出来的数值会偏小'
      })
    }
  }
]
